export default __webpack_public_path__ + "static/media/step3.ae90a0b0.svg";